import { render, staticRenderFns } from "./DrawingPage.vue?vue&type=template&id=78caff5f&scoped=true&"
import script from "./DrawingPage.vue?vue&type=script&lang=js&"
export * from "./DrawingPage.vue?vue&type=script&lang=js&"
import style0 from "./DrawingPage.vue?vue&type=style&index=0&id=78caff5f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78caff5f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VContainer,VLayout,VMain})
